import debounce from "../helpers/debounce";

class ReadMore {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.content = self.elem.querySelector('[data-read-more-content]');
        self.trigger = self.elem.querySelector('[data-read-more-trigger]');
        self.openLabel = self.elem.querySelector('[data-read-more-label-open]');
        self.closeLabel = self.elem.querySelector('[data-read-more-label-close]');
        self.isOpen = false;
    }

    init() {
        let self = this;

        // Enable truncation (if needed)
        self.toggleTruncation();

        // Enable truncation (if needed) on window resize
        let retoggleTruncation = debounce(function () {
            self.toggleTruncation();
        });

        window.addEventListener('resize', function () {
            retoggleTruncation();
        }, false);

        // List for button clicks
        self.trigger.addEventListener('click', evt => {
            if(self.isOpen) {
                self.close();
            } else {
                self.open();
            }
        });
    }

    open() {
        let self = this;

        self.elem.classList.add('is-open');
        self.openLabel.classList.add('d-none');
        self.closeLabel.classList.remove('d-none');
        self.isOpen = true;
    }

    close() {
        let self = this;

        self.elem.classList.remove('is-open');
        self.openLabel.classList.remove('d-none');
        self.closeLabel.classList.add('d-none');
        self.isOpen = false;
    }

    toggleTruncation() {
        let self = this;

        if(self.content.scrollHeight > self.content.clientHeight) {
            self.elem.classList.add('is-truncated');
        } else {
            self.elem.classList.remove('is-truncated');
        }
    }
}

export default ReadMore;
